import React from 'react'
import { useHistory } from 'react-router-dom'
import { Block, BlockGroup, Button, Text } from '@mote/ui'

export const SchoolsTierPricingSection = () => {
  const history = useHistory()

  return (
    <BlockGroup gap={20}>
      <Block gap={4} margin='17px 0 0 0'>
        <Text tag='p' fontSize={14} color='#AC0AE8'>
          Huge Discounts!
        </Text>

        <Text tag='p' fontSize={21} fontWeight={400}>
          Custom pricing
        </Text>
      </Block>
      <Button
        testId='get-quote-button'
        text='Get a quick quote'
        style={{ text: { fontWeight: 400 } }}
        onClick={() => history.push('/checkout/schools')}
      />
    </BlockGroup>
  )
}
